(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/standard.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/standard.js'); "use strict";

const {
  Betslip
} = svs.components.tipsen.betslipParts;
const Standard = () => React.createElement("div", {
  className: "pg_tipsen_content"
}, React.createElement("span", {
  className: "pg_tipsen_betslip_system_info"
}, React.createElement(Betslip.HedgesView, null)), React.createElement("span", {
  className: "pg_tipsen_betslip_price"
}, "124 KR"), React.createElement("span", {
  className: "pg_tipsen_betslip_pay_button"
}, "Betala"));
setGlobal('svs.components.tipsen.betslipSelector1x2.betslips.Standard', Standard);
 })(window);